import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

interface UseGetPropertyByIdProps {
  property_id: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyById = async (id: string, communityId: string) =>
  await axiosAuth.get(`${PROPERTY(communityId)}/${id}`);

const useGetPropertyById = ({
  property_id,
  communityId,
  queryParams,
}: UseGetPropertyByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property", property_id],
    queryFn: () => getPropertyById(property_id, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyById;
